(function() {
    'use strict';

    angular.module('order')
        .controller('PreviewModalController', PreviewModalController);

    PreviewModalController.$inject = [
        'lodashService',
        '$uibModalInstance',
        'orderProduct',
        'previewLoadingConst'
    ];

    function PreviewModalController(lodashService, $uibModalInstance, orderProduct, previewLoadingConst) {
        var self = this;

        self.orderProduct = orderProduct;
        self.previewLoading = true;
        self.pagesLoaded = 0;
        self.pagesLoadingText = previewLoadingConst.pagesLoadingText;
        self.ok = ok;

        function ok() {
            $uibModalInstance.close(self.orderProduct);
            self.orderProduct = null;
        }
    }
})();
